import { UserService } from '../../api';
import { DefaultQueryKeyFactory, QueryKeyFactoryGenerator } from '../../utils/query-keys-factory';

export const userQueryKeys = new QueryKeyFactoryGenerator<DefaultQueryKeyFactory>(
  'user'
).getDefault<typeof UserService.userList>();
